import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GCRoleType, GCRoleTypeOptions } from '@apply/constants';
import { isMobileScreen } from '@apply/ui';

export interface GeneralContractorCellProps {
    generalContractName: string | undefined;
    role: GCRoleType | undefined;
}

export const GeneralContractorCell: React.FC<GeneralContractorCellProps> = ({ generalContractName, role }) => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            {generalContractName && (
                <div className={`manageUsersByPropertyTable-generalContractor ${mobileScreen ? 'mobile' : ''}`}>
                    <FontAwesomeIcon
                        icon={faHardHat}
                        style={{ paddingRight: '15px' }}
                    />
                    <div className='manageUsersByPropertyTable-generalContractor-name'>{generalContractName}</div>
                    {role != undefined && (
                        <div className='manageUsersByPropertyTable-generalContractor-role'>
                            {GCRoleTypeOptions.find((o) => o.id == role)?.name}
                        </div>
                    )}
                </div>
            )}
            {!generalContractName && !mobileScreen && (
                <div className='manageUsersByPropertyTable-generalContractor-none'>No User Assigned</div>
            )}
        </>
    );
};
